export default {
    approvalInquiry: 'อนุมัติคำร้องขอ',
    typeInquiry: 'ประเภทคำร้องขอ',
    status: 'สถานะ',
    allType: 'ทุกประเภท',
    employeeNo: 'รหัสพนักงาน',
    name: 'ชื่อ',
    date: 'วันที่',
    approve: 'อนุมัติ',
    reject: 'ไม่อนุมัติ',
    personalLeave: 'ลากิจ',
    sickLeave: 'ลาป่วย',
    onSite: 'เข้าหน้างาน',
    allTypeMessage: 'ลาหรือขอไปทำงานนอกสถานที่',
    inquiryMessageType: 'ไม่พบข้อมูลการขอ$typeของวันที่ ',
    msgSuccess: 'บันทึกสำเร็จ',
    cannotGetLineId: 'เกิดข้อผิดพลาด'
}
